import { Button } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';
import NavigationConfig from '../../../../navigation/config';
import { allowedActions } from '../../configuration';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import { useDispatch } from 'react-redux';

interface IProps {
  vat_return_id: number;
  status: string;
  state: string;
  is_sent: number;
}

export default function ActionsBlock(props: IProps) {
  const history = useHistory();
  const ROLE = AuthSelectors.useSelectUserRole();
  const dispatch = useDispatch();

  const handleClick = (type: 'view' | 'edit') => {
    history.push(
      NavigationConfig.vatReturnDetailPage(`${props.vat_return_id}`, type).path
    );
  };

  const addPayment = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_ADD_VAT_RETURN_PAYMENT,
        params: {
          vat_number: props.vat_return_id,
        },
      })
    );
  };

  return (
    <div>
      {allowedActions.payment.roles.includes(ROLE) && (
        <Button
          disabled={
            !allowedActions.payment.state_status.includes(
              `${props.status}${props.state}`
            ) || props.is_sent == 0
          }
          onClick={() => addPayment()}
        >
          Payment
        </Button>
      )}
      {allowedActions.edit.roles.includes(ROLE) && (
        <Button
          disabled={
            !allowedActions.edit.state_status.includes(
              `${props.status}${props.state}`
            )
          }
          onClick={() => handleClick('edit')}
        >
          Edit
        </Button>
      )}
      <Button onClick={() => handleClick('view')}>View</Button>
    </div>
  );
}
